import { useQuery } from '@tanstack/react-query';
import fetchUsers from '../../../api/administration/users';

export const useUsers = (filters, options = {}) => {
  const query = useQuery({
    queryKey: ['users', filters],
    queryFn: () => fetchUsers(filters),
    keepPreviousData: true,
    enabled: options.enabled,
  });

  const users =
    query.data?.data?.users ??
    query.data?.users ??
    (Array.isArray(query.data?.data) ? query.data.data : []) ??
    [];

  const pagination =
    query.data?.data?.pagination ??
    query.data?.pagination ??
    {
      currentPage: 1,
      pageSize: filters?.limit ?? filters?.pageSize ?? 10,
      totalItems: 0,
      totalPages: 0,
      hasNextPage: false,
      hasPrevPage: false,
    };

  return {
    ...query,
    users,
    pagination,
  };
};

export default useUsers;
